export enum InvoiceState {
  Draft = "draft",
  Emitted = "emitted",
  Sent = "sent",
  Paid = "paid",
}
